export const PA_HISTORY_SEARCH = 'paHistorySearch';
export const PA_HISTORY_EXPORT = 'paHistoryExport';
export const PA_HISTORY_SEARCH_METRICS = 'paHistorySearchMetrics';



// WEBPACK FOOTER //
// ./src/store/pa/actions.type.js